import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/PageHeader";
import { Search, Briefcase, Users, CreditCard, Loader2, ArrowUpRight } from "lucide-react";

export default function ClientDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/client/overview").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s) return <div className="h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>;

  const cards = [
    { label: "Active Searches", value: s.searches, icon: Search, to: "/client/searches" },
    { label: "Shared Candidates", value: s.shared_candidates, icon: Users, to: "/client/searches" },
    { label: "Job Postings", value: s.jobs, icon: Briefcase, to: "/client/jobs" },
    { label: "Open Invoices", value: s.open_invoices, icon: CreditCard, to: "/client/billing" },
  ];
  return (
    <div>
      <PageHeader overline={`Welcome, ${user?.full_name?.split(" ")[0] || ""}`} title="Client Dashboard" />
      <div className="p-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 border border-black/10">
          {cards.map((c) => (
            <button key={c.label} onClick={() => navigate(c.to)} data-testid={`cstat-${c.label.toLowerCase().replace(/\s/g,'-')}`}
              className="group bg-white p-6 text-left hover:bg-[#F1F1F3] transition-colors relative">
              <c.icon className="h-5 w-5 text-muted-foreground group-hover:text-primary transition-colors" strokeWidth={1.5} />
              <p className="font-heading font-black text-5xl mt-6 tracking-tight">{c.value}</p>
              <p className="overline mt-2">{c.label}</p>
              <ArrowUpRight className="h-4 w-4 absolute top-6 right-6 text-transparent group-hover:text-primary transition-colors" />
            </button>
          ))}
        </div>
        <div className="mt-8 border border-black/10 bg-white p-8">
          <p className="overline mb-2">Getting started</p>
          <h2 className="font-heading font-bold text-xl">Post a role or review your shortlists</h2>
          <p className="text-sm text-muted-foreground mt-2 max-w-lg">Publish a standard or featured job posting to reach vetted candidates, or open a search to review recruiter-shared candidates.</p>
          <div className="flex gap-3 mt-6">
            <button onClick={() => navigate("/client/jobs")} className="px-5 py-2.5 text-sm bg-primary text-white hover:bg-[#09090B] transition-colors">Post a job</button>
            <button onClick={() => navigate("/client/searches")} className="px-5 py-2.5 text-sm border border-black/10 hover:bg-black/5 transition-colors">View searches</button>
          </div>
        </div>
      </div>
    </div>
  );
}
